/** Décision du contrôle d'UO avant l'ouverture d'une ressource (formulaire, brouillon, duplication, inbox). */
export enum OuDecisionKind {
  /** Ouverture directe dans l'UO courante. */
  Open = 'open',
  /** La ressource relève d'une autre UO accessible : proposer de basculer. */
  SwitchTo = 'switchTo',
  /** La ressource relève d'une UO hors du périmètre de l'utilisateur. */
  Unauthorized = 'unauthorized',
}
